module.exports = __webpack_public_path__ + "static/icon192x192-7ae32801143709a39bcc1cb91be2780b.png";